import axios from "../utils/http/axios";
import router from "../router";
import { useI18n } from "vue-i18n";
import { ServerName } from "../utils/constants/serverName";
import { Tenant, UserProfile } from "../models/user";
import { notification } from "ant-design-vue";
import { showNotification } from "@/service/notification";
export const getTenantConfiguration = async (tenantId: number) => {
  try {
    const response = await axios.get<Tenant>(`${ServerName}/tenantprofile/${tenantId.toString()}`);
    return Promise.resolve(response.data);
  } catch (error: any) {
    return Promise.reject(error);
  }
};

export const onDeleteTenant = async (tenantId: string | number) => {
  tenantId = tenantId.toString();
  if (!tenantId) {
    return Promise.reject();
  }
  if (tenantId === "") {
    return Promise.reject();
  }
  try {
    const response = await axios.delete(`${ServerName}/admin/tenant/${tenantId}`, {
      timeout: 120000,
    });
    return Promise.resolve(response.data);
  } catch (error: any) {
    return Promise.reject(error);
  }
};

export const onDeleteTenantData = async (tenantId: string | number) => {
  tenantId = tenantId.toString();
  if (!tenantId) {
    return Promise.reject();
  }
  if (tenantId === "") {
    return Promise.reject();
  }
  try {
    const response = await axios.delete(`${ServerName}/admin/tenant/${tenantId}/data`, {
      timeout: 120000,
    });
    return Promise.resolve(response.data);
  } catch (error: any) {
    return Promise.reject(error);
  }
};

export const getAllTenants = async () => {
  try {
    const response = await axios.get<Tenant[]>(`${ServerName}/tenantprofile/all`);
    return Promise.resolve(response.data);
  } catch (error: any) {
    return Promise.reject(error);
  }
};
export const updateTenantConfiguration = async (newConfiguration: Tenant) => {
  return axios
    .put<Tenant>(`${ServerName}/tenantprofile/${newConfiguration.id.toString()}`, newConfiguration)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
};

export const addNewTenant = (data: Tenant) => {
  return axios
    .post<Tenant>(`${ServerName}/tenantprofile`, data)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getUserConfiguration = async () => {
  return axios
    .get<UserProfile>(`${ServerName}/user/me`)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
